<template>
  <div class="the-navbar__user-meta flex items-center" v-if="displayName">

      <vx-tooltip :htmlEnabled="true" position="bottom" :text="lastActionToReverse" v-if="lastActionToReverse" class="mr-4 inline">
        <div class="items-center flex flex-col track-undo" :class="actionElementCss" @click="handleUndo">
          <feather-icon icon="RotateCcwIcon" svgClasses="h-4 w-4" />
          undo
        </div>
      </vx-tooltip>


   <ActionBoardFilter v-if="$store.getters.betaFeatures" class="mx-2"/>

    <vs-dropdown :key="dropdownKey" vs-custom-content vs-trigger-click class="cursor-pointer">

    <div class="flex items-center text-base ">
        <div class="text-right leading-tight hidden sm:block ">
          <p class="hover:underline font-semibold select-none text-danger" v-if="expired">
            Membership expired
          </p>
          <p class="hover:underline font-semibold select-none text-danger" v-else-if="invoiceOverdue">
            Your payment is overdue
          </p>
          <p v-else class="hover:underline font-semibold select-none">{{ displayName }}</p>
        <!-- <small>Available</small> -->
      </div>
      <div class="the-navbar__avatar con-img ml-3">
        <img v-if="photoURL" key="onlineImg" :src="photoURL" alt="user-img" width="40" height="40" class="rounded-full shadow-md cursor-pointer block" />
      </div>
    </div>


      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 14rem">

          <!--
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/pages/profile').catch(() => {})">
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Profile</span>
          </li>

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/apps/email').catch(() => {})">
            <feather-icon icon="MailIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Inbox</span>
          </li>

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/apps/todo').catch(() => {})">
            <feather-icon icon="CheckSquareIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Tasks</span>
          </li>

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/apps/chat').catch(() => {})">
            <feather-icon icon="MessageSquareIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Chat</span>
          </li>

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/apps/eCommerce/wish-list').catch(() => {})">
            <feather-icon icon="HeartIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Wish List</span>
          </li>

          <vs-divider class="m-1" />
          -->

          <li v-if="isAnonymous"
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="register">

              <feather-icon class="text-danger font-bold" icon="HeartIcon" svgClasses="w-5 h-5" />
              <span class="ml-2 font-semibold">Register</span>

          </li>
          <li v-if="!isAnonymous && free"
            class="flex py-2 px-4 cursor-default"
            >

            <feather-icon icon="HeartIcon" class="font-bold" svgClasses="w-4 h-4" />
            <span class="ml-2 font-semibold" >Trial membership</span>
          </li>
          <li v-if="!isAnonymous && (trial || expired)"
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" :class="{'text-danger': expired}" @click="showMembershipInfo"
            >

            <feather-icon :icon="tarifIcon" class="font-bold" svgClasses="w-4 h-4" />
            <span class="ml-2 font-semibold">{{membershipTitle}}<span v-if="daysLeftText" class="text-xs ml-1">{{daysLeftText}}</span></span>

          </li>

          <li v-else-if="!isAnonymous && regular"
            class="track-customer-profile-open flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="redirectToCustomerProfile"
            >

            <feather-icon :icon="tarifIcon" class="font-bold" svgClasses="w-4 h-4" />
            <span class="ml-2 font-semibold">Member

              <!-- <span v-if="daysLeftText" class="text-xs ml-1">{{daysLeftText}}</span>
               -->
              </span>
          </li>

          <li v-else-if="invoiceOverdue"
            class="track-customer-profile-open flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white text-danger"
            @click="redirectToCustomerProfile"
            >

            <feather-icon icon="UserXIcon" class="font-bold" svgClasses="w-4 h-4" />
            <span class="ml-2 font-semibold">Fix membership

              <!-- <span v-if="daysLeftText" class="text-xs ml-1">{{daysLeftText}}</span>
               -->
              </span>
          </li>

<!--         <li v-if="expired"
            class="flex py-2 px-4 cursor-default"
            >

              <feather-icon :icon="tarifIcon" svgClasses="w-4 h-4" />
              <span class="ml-2 font-semibold" >{{membershipTitle}}</span>

          </li> -->

          <!-- <vs-divider class="m-1" /> -->
<!--           <vs-divider class="m-1" />
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="toggleTheme">
            <feather-icon :icon="themeIcon" svgClasses="w-4 h-4" />
            <span class="ml-2 capitalize">{{ theme == 'dark' ? 'dark' : 'light' }}</span>
          </li>
 -->

<!--           <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="onboardingTour">
            <feather-icon icon="HelpCircleIcon" svgClasses="w-4 h-4" />
            <span class="ml-2 capitalize">Tour</span>
          </li>
 -->
          <vs-divider class="m-1" />

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="openBackgroundImagePicker">

              <feather-icon icon="ImageIcon" svgClasses="w-4 h-4" />
              <span class="ml-2">Appearance settings</span>
          </li>
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="openAi">
              <feather-icon icon="TerminalIcon" svgClasses="w-4 h-4" />
              <span class="ml-2">My AI coach</span>
          </li>
          <vs-divider class="m-1"  />
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="visitLanding">
              <feather-icon icon="CompassIcon" svgClasses="w-4 h-4" />
              <span class="ml-2">About improvee.io</span>

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="earnPassiveIncome">

              <feather-icon icon="DollarSignIcon" svgClasses="w-4 h-4" />
              <span class="ml-2">Earn passive income</span>
          </li>
          
<!--           <li v-if="trial"
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="inviteFriends">

              <feather-icon icon="ThumbsUpIcon" svgClasses="w-4 h-4" />
              <span class="ml-2" >Invite friends</span>
          </li> -->
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="sendUsFeedback">
              <feather-icon icon="MessageCircleIcon" svgClasses="w-4 h-4" />
              <span class="ml-2">Send feedback</span>
          </li>
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="getApp">
              <feather-icon icon="SmartphoneIcon" svgClasses="w-4 h-4" />
              <span class="ml-2">Install app</span>
          </li>
          <vs-divider class="m-1" v-if="!isAnonymous" />
          <li v-if="!isAnonymous"
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout">
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Logout</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>

    <InviteFriendPopup ref="inviteFriendsPopup"/>
    <BuyMePopup ref="buyMePopup"/>
    <GeneralPopup :showPopup="backgroundImagePopupOpen" componentName="BackgroundPicker" @popupHidden="backgroundImagePopupOpen=false" />

    <GeneralPopup :showPopup="earnPassiveIncomePopupOpen" componentName="EarnPassiveIncome" @popupHidden="earnPassiveIncomePopupOpen=false" />

    <GeneralPopup :showPopup="improveeAiPopupOpen" componentName="ImproveeAi" @popupHidden="improveeAiPopupOpen=false" />

    <GeneralPopup :showPopup="getAppPopupOpen" componentName="DownloadApp" @popupHidden="getAppPopupOpen=false" />



     <form ref="customerProfile" method="POST" action="/create-customer-portal-session">
        <input type="hidden" name="id" :value="stripeCustomerId"/>
        <input type="hidden" name="return_url" :value="returnUrl"/>
      </form>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import trackAnalytics from '@/helpers/trackAnalytics'
import id from '@/helpers/id'
import BuyMePopup from '@/views/Self-Improvee/Membership/BuyMePopup'
import * as D from '@/helpers/date'

export default {
  components: {
    BuyMePopup
  },
  computed: {
    lastActionToReverse () {
      if (!this.$store.getters.lastAction) return
      if (this.$route.name != "planner") return

      if (this.$store.getters.lastAction.action) {

        return this.$store.getters.lastAction.reverse_detail +  " <strong>" +  this.$store.getters.lastAction.title + "</strong> "
      }
    },
    stripeCustomerId () {
      return this.$store.getters.stripeCustomerId
    },
    returnUrl () {
      return window.location.origin
    },
    displayName () {
      return this.userInfo.displayName || 'Unregistered Achiever'
    },
    daysLeftText () {
      if (!this.tarifMissingDays) { return }

      if (this.tarifMissingDays >= 0) {
        if (this.tarifMissingDays === 0) {
          return '(ending today)'
        } else if (this.tarifMissingDays === 1) {
          return '(ending tomorrow)'
        } else {
          return `(${this.tarifMissingDays} days left)`
        }
      }
    },
    isAnonymous () {
      return this.userInfo.isAnonymous
    },
    userInfo () {
      return this.$store.getters.userInfo
    },
    photoURL () {
      if (!this.userInfo.photoURL || _.includes(this.userInfo.photoURL, 'defaultAvatar')) {
        return require('@/assets/images/portrait/small/defaultAvatar.svg')
      } else {
        return this.userInfo.photoURL
      }
    },
    theme () {
      return this.$store.state.theme === 'dark' ? 'light' : 'dark'
    },
    themeIcon () {
      return this.theme === 'dark' ? 'MoonIcon' : 'SunIcon'
    },
    membershipTarif () {
      return this.$store.getters.userMembership.tarif
    },
    trial () {
      return this.membershipTarif === 'trial'
    },
    free () {
      return this.membershipTarif === 'free' || this.membershipTarif === 'pretrial'
    },
    regular () {
      return this.membershipTarif === 'regular' && !this.invoiceOverdue
    },
    invoiceOverdue () {
      return this.$store.getters.invoiceOverdue
    },
    expired () {
      return this.membershipTarif === 'expired'
    },
    tarifMissingDays () {
      if (this.$store.getters.userMembership.endsOn) {
        return -D.daysSinceDate(this.$store.getters.userMembership.endsOn)
      } else {
        return null
      }

    },
    tarifIcon () {
      switch (this.membershipTarif) {
      case 'trial':
        return 'GiftIcon'
      case 'regular':
        return 'UserCheckIcon'
      case 'expired':
        return 'UserXIcon'
      }
    },
    membershipTitle () {
      switch (this.membershipTarif) {
      case 'trial':
        return 'Trial'
      case 'regular':
        return 'Regular'
      case 'expired':
        return 'Expired'
      }
    }

  },
  data () {
    return {
      dropdownKey: `dropdown_${id()}`,
      backgroundImagePopupOpen: false,
      earnPassiveIncomePopupOpen: false,
      improveeAiPopupOpen: false,
      getAppPopupOpen: false
    }
  },
  methods: {
    redirectToCustomerProfile () {
      if (this.stripeCustomerId) {
        this.$vs.notify({
          title: 'Wait a moment please',
          text: 'Your subscription page is opening...',
          iconPack: 'feather',
          icon: 'icon-dollar-sign',
          time: 4000,
          color: 'dark'
        })
        this.$refs.customerProfile.submit()
      } else {
        this.$vs.notify({
          title: 'Your subscription page',
          text: 'Will be created shortly...',
          iconPack: 'feather',
          icon: 'icon-dollar-sign',
          time: 4000,
          color: 'dark'
        })
      }
    },
    inviteFriends () {
      this.$refs.inviteFriendsPopup.show()
      this.dropdownClose()
    },
    showMembershipInfo () {
      this.$refs.buyMePopup.show()
      this.dropdownClose()
    },
    openAi () {
      this.dropdownClose()
      this.improveeAiPopupOpen = true
    },
    openBackgroundImagePicker () {
      this.backgroundImagePopupOpen = true
      this.dropdownClose()
    },
    earnPassiveIncome () {
      this.earnPassiveIncomePopupOpen = true
      this.dropdownClose()
    },
    getApp () {
      this.getAppPopupOpen = true
      this.dropdownClose()
    },
    dropdownClose () {
      this.dropdownKey = `dropdown_${id()}`
    },
    logout () {
      trackAnalytics(this, 'app_action', 'logout', 'Profile -> Logout')

      // if user is logged in via auth0
      // if (this.$auth.profile) this.$auth.logOut()

      // if user is logged in via firebase
      if (firebase.auth().currentUser) {
        firebase.auth().signOut().then(() => {
          this.$router.push('/login').catch(() => {})
        })
      }

      // If JWT login
      // if (localStorage.getItem('accessToken')) {
      //   localStorage.removeItem('accessToken')
      //   this.$router.push('/').catch(() => {})
      // }

      // Change role on logout. Same value as initialRole of acj.js
      // this.$acl.change('admin')
      localStorage.removeItem('userInfo')

      // window.location.replace('/')
    },
    handleUndo () {
      const lastAction = this.$store.getters.lastAction
      if (!lastAction) return

      this.$store.dispatch('UNDO')
    },
    register () {
      this.$router.push('/login').catch(() => {})
    },
    toggleTheme () {
      this.$store.dispatch('updateTheme', this.theme)
    },
    onboardingTour () {
      trackAnalytics(this, 'onboarding_tour', 'restart')

      if (this.$route.name === 'planner') {
        this.$store.commit('SET_ONBOARDING_TOUR_FINISHED', false)
      } else {
        this.$router.push('planner', () => { this.$store.commit('SET_ONBOARDING_TOUR_FINISHED', false) }).catch(() => {})
      }

      this.dropdownClose()
    },
    sendUsFeedback () {
      trackAnalytics(this, 'app_action', 'click', 'send_us_feedback')
      window.open('https://forms.gle/XQUYAc99kHwCM2iQA', '_blank')
      this.dropdownClose()
    },
    buyUsCoffee () {
      trackAnalytics(this, 'app_action', 'click', 'buy_us_coffee')
      window.open('https://www.buymeacoffee.com/selfimprovee', '_blank')

      this.dropdownClose()
    },
    visitLanding () {
      trackAnalytics(this, 'app_action', 'click', 'visit_landing')
      window.open('/landing', '_blank')

      this.dropdownClose()
    }
  }
}
</script>
